import { render, staticRenderFns } from "./Busca.vue?vue&type=template&id=30af5c7a"
import script from "./Busca.vue?vue&type=script&lang=js"
export * from "./Busca.vue?vue&type=script&lang=js"
import style0 from "./Busca.vue?vue&type=style&index=0&id=30af5c7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports